<template>
  <div class="v2-events-redirect">
    <v-icon size="32" color="grey lighten-1">mdi-progress-clock</v-icon>
    <p class="v2-body v2-body--sm v2-body--muted">Redirigiendo…</p>
  </div>
</template>

<script>
export default {
  name: "MemberDashboardV2MyEventsRedirect",
  created() {
    const target = { path: "/member-v2/events", query: { tab: "my" } };
    this.$router.replace(target);
  },
};
</script>

<style scoped>
.v2-events-redirect {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-10);
}
</style>
